import React from 'react';

export default function ChildSafetyPolicy() {
  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      maxWidth: '800px',
      margin: '40px auto',
      padding: '0 20px',
      color: '#333',
      textAlign: 'left',
    }}>
      <h1 style={{
        color: '#800020',
        borderBottom: '2px solid #800020',
        paddingBottom: '10px',
        fontSize: '2rem',
        fontWeight: 'bold'
      }}>
        Child Safety Standards & Prevention Policy
      </h1>

      <p style={{ marginTop: '10px', color: '#666' }}>
        <strong>Effective Date:</strong> July 2026
      </p>

      <p style={{ marginTop: '20px' }}>
        KalyanaSapthapadhi Matrimony is a community matchmaking platform strictly reserved for adults aged 18 and older. Despite our strict age restrictions, we maintain an absolute zero-tolerance policy regarding Child Sexual Abuse Material (CSAM) and Child Sexual Abuse and Exploitation (CSAE).
      </p>

      <h1 style={{ color: '#444', marginTop: '30px', fontSize: '2rem', fontWeight: 'bold' }}>
        1. Prohibited Activities & Content
      </h1>
      <p>
        Any attempt to upload, share, transmit, or promote content containing child exploitation or abuse material will result in an immediate, permanent ban from the platform without prior notice. The associated user account data will be preserved and reported to appropriate regional and national law enforcement authorities.
      </p>

      <h1 style={{ color: '#444', marginTop: '30px', fontSize: '2rem', fontWeight: 'bold' }}>
        2. In-App Reporting & Moderation Mechanisms
      </h1>
      <p>
        KalyanaSapthapadhi includes active on-screen blocking and reporting mechanisms on every user profile. Users can immediately report any suspicious behavior or policy violations. Our administrative team reviews all user-submitted reports within 24 hours to ensure immediate removal of any non-compliant content or bad actors.
      </p>

      <h1 style={{ color: '#444', marginTop: '30px', fontSize: '2rem', fontWeight: 'bold' }}>
        3. Compliance and Point of Contact
      </h1>
      <p>
        Our designated administrative contact is fully equipped to address, manage, and act upon any platform safety or compliance concerns. For urgent inquiries regarding our child safety practices, please contact us directly:
      </p>

      <p style={{ marginTop: '15px', padding: '15px', backgroundColor: '#f9f9f9', borderRadius: '5px', borderLeft: '4px solid #800020' }}>
        <strong>Designated Contact Email:</strong>{' '}
        <a href="mailto:admin@kalyanasapthapadhi.com" style={{ color: '#800020', textDecoration: 'underline' }}>
          admin@kalyanasapthapadhi.com
        </a>
      </p>
    </div>
  );
}